<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title" style="margin-top: 7px">
          Müşteri Suspend İşlemleri
        </h3>
        <div class="card-tools">
          <button
            class="btn btn-primary btn-sm"
            v-if="suspend.type == null"
            @click="modal"
          >
            Hesabı Suspend Et
          </button>
          <button
            class="btn btn-primary btn-sm"
            v-if="suspend.type != null"
            @click="modal"
          >
            Hesabı Aktifleştir
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive p-0" style="height: 500px">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>

          <table class="table  table-striped projects">
            <thead>
              <tr>
                <th style="width: 1%">#</th>
                <th>Tarih</th>
                <th>İşlem Tipi</th>
                <th>Yetkili</th>
                <th>Durum</th>
                <th>Aktifleşme Tarihi</th>
                <th>Aktifleştiren Personel</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in datas" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ data.date | DateFormat }}</td>
                <td>
                  {{ data.type ? "Çekim" : "Yatırım" }}
                </td>
                <td>{{ data.user }}</td>
                <td>
                  {{ data.active ? "Hesap Aktif" : "Hesap Suspend" }}
                </td>
                <td>{{ data.activeDate | DateFormat }}</td>
                <td>{{ data.activeUser }}</td>
                <td>
                  <button class="btn btn-primary btn-sm" @click="detail(data)">
                    <i class="fas fa-eye"></i> Detaylar
                  </button>
                </td>
              </tr>
              <tr>
                <td v-if="datas.length == 0" colspan="8" class="text-center">
                  Kayıt Bulunamadı
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <div class="modal fade" id="modal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Suspend Detayları</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>
              <b>Suspend Sebebi :</b>
              {{ data.type ? "Çekim" : "Yatırım" }} İşlemi
            </h5>

            <p>
              {{ data.message }}
            </p>
            <hr />
            <h5>
              <b>Hesap Açılma Notu</b>
            </h5>

            <p v-if="data.active">
              {{
                data.activeMessage == "" ? "Not Eklenmemiş" : data.activeMessage
              }}
            </p>
            <p v-if="!data.active">Hesap halen suspend durumda</p>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Kapat
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modal-suspend">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{
                suspend.type == null
                  ? "Hasabı Suspend Et"
                  : "Hesabı Aktifleştir"
              }}
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group" v-if="suspend.active==null">
                <label>Suspend Sebebi</label>
                <select
                  @blur="$v.suspend.type.$touch()"
                  v-model="$v.suspend.type.$model"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': $v.suspend.type.$error }"
                  placeholder="Departman adını giriniz"
                >
                  <option :value="null">Sebep Seçiniz</option>
                  <option :value="true">Çekim İşlemi</option>
                  <option :value="false">Yatırım İşlemi</option>
                </select>
                <small
                  v-if="!$v.suspend.type.required && $v.suspend.type.$error"
                  class="form-text text-danger"
                  >Bu alan zorunludur...</small
                >
              </div>
              <div class="form-group" >
                <label>Açıklama</label>
                <textarea
                  v-model="suspend.message"
                  class="form-control"
                  placeholder="Açıklama giriniz"
                ></textarea>
              </div>
            </form>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Kapat
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              :disabled="$v.suspend.$invalid"
            >
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: ["customer"],
  data() {
    return {
      datas: [],
      data: [],
      suspend: [],
      search: "",
      overlay: false,
    };
  },
  validations: {
    suspend: {
      type: {
        required,
      },
    },
  },
  methods: {
    getDatas() {
      this.overlay = true;
      this.$http
        .get("Suspend/ListSuspend/" + this.customer.code)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
    getData() {
      this.overlay = true;
      this.$http.get("Suspend/GetSuspend/" + this.customer.code).then(
        (response) => {
          this.suspend = response.data;
          this.suspend.message = response.data.activeMessage
          this.overlay = false;
        },
        (err) => {
          this.suspend = { type: null, message: "" };
        }
      );
    },
    detail(item) {
      this.data = item;
      $("#modal").modal();
    },
    modal() {
      this.$v.suspend.$reset();
      $("#modal-suspend").modal();
    },
    save() {
      let url = "Suspend/AddSuspend/"

      if(this.suspend.active == false)
        url = "Suspend/DeleteSuspend/"
      
      this.overlay = true;
      this.$http
        .post(url, {
          code: this.customer.code,
          message: this.suspend.message,
          type: this.suspend.type,
        })
        .then(
          (response) => {
            toastr.success("Kayıt başarılı.");
            this.getDatas();
            this.getData();
            this.overlay = false;
            $("#modal-suspend").modal("hide");
          },
          (err) => {
            toastr.error("İşlem sırasında bir hata oluştu!");
            this.overlay = false;
          }
        );
    },
  },
  filters: {
    DateFormat(value) {
      if (!value) return "";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  },

  created() {
    this.getDatas();
    this.getData();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerSuspend.vue